import { TextField, TextFieldProps } from "@mui/material";
import {
  DateTimePicker,
  DateTimePickerProps,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

type Props = Omit<DateTimePickerProps<Date, Date>, "renderInput"> & {
  required?: boolean;
  textFieldProps?: TextFieldProps;
};

export default function CustomDatePicker({
  required,
  textFieldProps,
  ...props
}: Props) {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      localeText={{
        todayButtonLabel: "Use Current Time",
      }}
    >
      <DateTimePicker
        inputFormat="DD/MM/YYYY hh:mm A"
        renderInput={(inputProps) => (
          <TextField
            {...inputProps}
            fullWidth
            InputLabelProps={{ shrink: true }}
            helperText={null}
            size="small"
            required={required}
            {...textFieldProps}
            sx={{
              "& .MuiOutlinedInput-root.Mui-disabled": {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderStyle: "none",
                },
                //hide calender 
                "& .MuiInputAdornment-root": {
                  display: "none",
                },
              },
            }}
          />
        )}
        componentsProps={{
          actionBar: {
            actions: ["today"],
          },
        }}
        {...props}
      />
    </LocalizationProvider>
  );
}
